<!-- Location Admin table -->
@if (selectedFilter === filter.LOCATIONADMIN) {
  <app-location-admin-table
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [hasRadioButton]="true"
    [radioHeader]="CONSTANTS.SEARCH_TYPE"
    [firstOptionValue]="'locationadmin'"
    [firstOptionName]="CONSTANTS.CRITERIA_1"
    [secondOptionValue]="'useradmin'"
    [secondOptionName]="CONSTANTS.CRITERIA_2"
    [radioModel]="selectedFilter"
    [isAdminSearch]="true"
    (radioButtonChange)="radioGroupValue($event)"
  ></app-location-admin-table>
}

<!-- User Admin table -->
@if (selectedFilter === filter.USERADMIN) {
  <app-user-admin-table
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [hasRadioButton]="true"
    [radioHeader]="CONSTANTS.SEARCH_TYPE"
    [firstOptionValue]="'locationadmin'"
    [firstOptionName]="CONSTANTS.CRITERIA_1"
    [secondOptionValue]="'useradmin'"
    [secondOptionName]="CONSTANTS.CRITERIA_2"
    [radioModel]="selectedFilter"
    [hasNoButtons]="true"
    [isAdminSearch]="true"
    (radioButtonChange)="radioGroupValue($event)"
  ></app-user-admin-table>
}
